<template>
  <div class="detail">
    <div class="register_title">{{ info.detailtbname }}</div>
    <div v-for="(item, index) in form" :key="index" class="dson" v-show="item.show">
      <!-- 不能用v-if去掉wxform，只能隐藏，然后保存时，排除show=false的触发保存 -->
      <template >
        <div class="title">
          <span>{{ info.detailtbname + getSqnum(index) }}</span>
          <div @click="del(item)">
            <svg-icon icon-class="slectJobNumDel" class="icons" />
          </div>

          <!-- <svg-icon icon-class="wenhao" class="icons" /> -->
        </div>
        <!-- 基本信息 -->
        <wxForm
          ref="wxForm"
          :acceptid="item.autoid"
          :addApiData="baseinfo"
          :moduleno="info.moduleno"
          :status="
            item.autoid === '0' || item.autoid === '' ? 'save' : 'modify'
          "
          :saveormodify="
            item.autoid === '0' || item.autoid === '' ? 'save' : 'modify'
          "
          :module-config="baseinfo.moduleconfiginfo[0]"
          :masterformstr="''"
          :masterisactive="'1'"
          :sqnum="getSqnum(index)"
          :isSon="isSon"
          :detailAtList="detailAtList"
          @getFormRecordData="getFormRecordData(index)"
          @writeSysTips="writeSysTips"
          @get="get"
          @updateformstr="updateformstr"
          @setCanSave="setCanSave"
        />
      </template>
    </div>
    <div class="bton" @click="add('0')">
      + &nbsp; 添加{{ info.detailtbname }}记录
    </div>
  </div>
</template>

<script>
import { Notify } from 'vant'
import {
  getInfo as getbaseforminfo,
  queryGridData,
  deleteFile,
  deleteRecord
} from '@/request/api.js'
import wxForm from './wxForm.vue'
import { createGguid } from '@/utils/index.js'
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    // 子表的附件名列表
    detailAtList: {
      type: Array,
      default: () => []
    },
    // 子表的序号
    index: {
      type: [String, Number],
      default: 0
    }
  },
  components: {
    wxForm
  },
  data() {
    return {
      loading: true,
      userInfo: { username: 'admin', userid: 1 }, // 用户登录信息
      baseinfo: { moduleconfiginfo: [{}] },
      form: [],
      isSon: true // 代表是子表
    }
  },
  created() {
    this.getBaseForm()
  },
  methods: {
    // 子表的临时保存
    saveTemporaryData() {
      if (this.$refs.wxForm) {
        console.log(this.$refs.wxForm, 'saveRsTempRecordData')
        for (let index = 0; index < this.$refs.wxForm.length; index++) {
          if (this.form[index].show) {
            const w = this.$refs.wxForm[index]
            w.saveRsTempRecordData()
          }
        }
      }
    },
    // 获取wxForm的loopData // 子表暂时作废
    getLoopData(data) {},
    getBaseForm() {
      this.loading = true
      getbaseforminfo({
        moduleno: this.info.moduleno,
        userid: this.userInfo.userid,
        langid: 0,
        flag: 0,
        mtag: this.info.id.substr(0, 1) === '4' ? '1' : '2'
      }).then(res => {
        // 获取子表接口信息
        this.baseinfo = res //子表模块配置
        // this.add()
        if (this.info.acceptid != '0' && this.info.acceptid != '') {
          //查询历史子表记录
          const data = res.moduleconfiginfo[0]
          const querysql =
            this.info.dtkeyfield + " = '" + this.info.acceptid + "'"
          const params = {
            moduleno: this.info.moduleno,
            userid: this.userInfo.userid,
            username: this.userInfo.username,
            hasempidfield: data.hasempidfield,
            mviewname: data.mviewname,
            fieldlist: data.fieldlist,
            orderbysql: data.orderbysql,
            pagequery: false,
            pagesize: 15,
            pageindex: 1,
            moduleqyfilter: data.moduleqyfilter,
            specfilter: data.specfilter,
            querysql: querysql,
            fastquerylist: ''
          }
          this.queryGridData(params)
        } else {
          // this.add('0')
        }
        // this.$refs.wxForm.fileList = []
      })
    },
    queryGridData(params) {
      queryGridData(params).then(res => {
        // 当没有查询到数据时则添加一笔新记录
        if (res.data.length > 0) {
          res.data.forEach(e => {
            this.add(e.autoid)
          })
        } else {
          // this.add('0')
        }
      })
    },
    add(autoid = '0') {
      // console.log(autoid,'autoid');
      this.form.push({
        id: createGguid(),
        autoid: autoid,
        show: true
      })
    },
    del(item) {
      let data = {
        autoidlist: item.autoid + '',
        formstr: '',
        guid: item.id,
        hascheckfield: false,
        haslockfield: false,
        isall: false,
        mkeyname: this.baseinfo.moduleconfiginfo[0].mkeyname,
        moduleno: this.info.moduleno,
        moduleqyfilter: this.baseinfo.moduleconfiginfo[0].moduleqyfilter,
        mtablename: this.baseinfo.moduleconfiginfo[0].mtablename,
        mviewname: this.baseinfo.moduleconfiginfo[0].mviewname,
        optionfilter: [],
        pcuserinfo: '',
        querysql: '',
        specfilter: '',
        username: this.userInfo.username
      }
      if (item.autoid > 0) {
        deleteRecord(data).then(res => {
          if (res.iserror == '0') {
            Notify({
              type: 'success',
              message: '删除成功！'
            })
            // this.form = this.form.filter(it => {
            //   return it.autoid != item.autoid
            // })
          } else {
            Notify({
              type: 'danger',
              message: res.errormsg
            })
          }
        })
      } else {
        Notify({
          type: 'success',
          message: '删除成功！'
        })
        // this.form = this.form.filter(it => {
        //   return it.id != item.id
        // })
      }
      item.show = false
      this.$forceUpdate()
      // this.$nextTick(() => {
      //   this.form = this.form.filter(it => {
      //     return it.show
      //   })
      // })
      console.log(this.form, 'this.formthis.formthis.formthis.form')
    },
    getFormRecordData(index) {
      this.form[index].autoid = this.$refs.wxForm[index].new_acceptid
    },
    writeSysTips(data) {
      // this.$message.error('data')
      Notify({
        type: 'danger',
        message: data
      })
    },
    get() {},
    updateformstr() {},
    setCanSave() {},
    setMautoid(mautoid) {
      if (this.$refs.wxForm) {
        for (let index = 0; index < this.$refs.wxForm.length; index++) {
          if (this.form[index].show) {
            const w = this.$refs.wxForm[index]
            w.setValue(this.info.dtkeyfield, mautoid)
          }
        }
      }
    },
    // 判断子表是否都已经必填了
    checkmustinput() {
      let cmip = false
      if (this.$refs.wxForm) {
        for (let index = 0; index < this.$refs.wxForm.length; index++) {
           if (this.form[index].show) {
          const w = this.$refs.wxForm[index]
          w.singleSel = true
          if (w.checkmustinput()) {
            cmip = true
            //this.ask('请填写必填项')
            break
          }
           }
        }
      }
      if (cmip) {
        this.$emit('changPage', this.index, 'son')
      }
      return cmip
    },
    async save() {
      if (this.$refs.wxForm) {
        for (let index = 0; index < this.$refs.wxForm.length; index++) {
           if (this.form[index].show) {
          const w = this.$refs.wxForm[index]
          w.singleSel = true
          if (w.checkmustinput()) {
            //this.ask('请填写必填项')

            break
          } else {
            console.log(index, 'index')
            try {
              let beforeAction = w.beforeAction(null)
              // console.log(2222, beforeAction)
              if (!beforeAction) {
                break
              }
            } catch (error) {}
          }
           }
        }
      }
    },
    async beforeAction() {
      let cmip = false
      if (this.$refs.wxForm) {
        for (let index = 0; index < this.$refs.wxForm.length; index++) {
           if (this.form[index].show) {
          const w = this.$refs.wxForm[index]
          w.singleSel = true
          if (w.checkmustinput()) {
            //this.ask('请填写必填项')
            cmip = true
            break
          } else {
            let onlycheck = true,
              beforeAction = true
            await w
              .beforeAction(null, onlycheck)
              .then(res => {
                beforeAction = res
              })
              .catch(err => {})
            if (!beforeAction) {
              cmip = true
              break
            }
          }
        }
        }
      }
      if (cmip) {
        this.$emit('changPage', this.index, 'son')
      }
      return cmip
    },
    getCount() {
      let num = 0
      if (this.$refs.wxForm) {
        for (let index = 0; index < this.$refs.wxForm.length; index++) {
           if (this.form[index].show) {
          const w = this.$refs.wxForm[index]
          w.singleSel = true
          if (w.checkmustinput()) {
            //this.ask('请填写必填项')

            break
          } else {
            num++
          }
           }
        }
      }
      return num
    },
    // 获取附件的数量
    getFileCount() {
      let num = 0
      if (this.$refs.wxForm) {
        for (let index = 0; index < this.$refs.wxForm.length; index++) {
           if (this.form[index].show) {
          const w = this.$refs.wxForm[index]
          w.singleSel = true
          if (w.checkmustinput()) {
            //this.ask('请填写必填项')
            break
          } else {
            num += w.fileList.length
          }
           }
        }
      }
      return num
    },
    getSqnum(index) {
      let num = 0
      for (let i = 0; i < index + 1; i++) {
        const w = this.form[i]
        if (w.show) num++
      }
      return num
    }
  }
}
</script>

<style scoped lang="less">
.detail {
  .register_title {
    font-size: 5vw;
    color: #303133;
    height: 11.46667vw;
    line-height: 11.46667vw;
    text-align: center;
    // border-bottom: 0.13333vw solid #eee;
    border-bottom: 0.13333vw solid #bababc;
    position: relative;
    width: 100vw;
    background: #fff;
  }
  .register_title:before {
    content: '';
    position: absolute;
    width: 2.66667vw;
    height: 11.46667vw;
    left: -1.33333vw;
    top: 0;
    bottom: 0;
    background-color: #287eff;
    border-radius: 1.33333vw;
  }
  .bton {
    width: 74vw;
    height: 10vw;
    margin: 2vw auto;
    color: #67c23a;
    background: #f0f9eb;
    border-color: #c2e7b0;
    border-radius: 0.5vw;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4.8vw;
    letter-spacing: 0.267vw;
  }
  .dson {
    .title {
      font-size: 4vw;
      color: #525252;
      height: 11.46667vw;
      line-height: 11.46667vw;
      background-color: #e7e7e7;
      padding: 0 5vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
